// extracted by mini-css-extract-plugin
export default {"PostTextPlusComments":"PostTextPlusComments_PostTextPlusComments__pBFto","Header":"PostTextPlusComments_Header__8sxO4","More":"PostTextPlusComments_More__JgP-c"};